export const environment = {
  "production": false,
  "apiEndPoint": "https://dev.invonow.com", // http://84.228.29.126:325
  "appVersion": "1.0"
};